import choozy from 'choozy'
import { component } from 'picoapp'
import { on } from 'martha'
import dcx from 'dcx'

export default component((node) => {
  const { button, form, cancelButton } = choozy(node)
  const formCx = dcx(form)
  let isFormActive = false

  on(button, 'click', () => {
    isFormActive = !isFormActive
    render()
  })

  on(cancelButton, 'click', () => {
    isFormActive = false
    render()
  })

  function render() {
    formCx({ hidden: !isFormActive })
  }
})
